/**
 * Creates an action object with default properties and merges additional data.
 *
 * @param {Object} data - Additional data to merge into the action object.
 * @param {string} [data.label] - The label for the action.
 * @param {string} [data.icon] - The icon for the action.
 * @param {Function} [data.handle] - The handler function for the action.
 * @param {boolean} [data.render] - Whether the action should be rendered.
 * @returns {Object} The action object with merged properties.
 */

export default (data) => {
  return {
    label: 'Akcja',
    icon: 'BoxIcon',
    handle: () => {},
    render: true,
    disabled: () => false,
    tooltip: {
      isActive: () => false,
      text: '',
    },
    ...data,
  };
};
